import { defineMessages } from 'react-intl.macro';
export default defineMessages({
  heading: {
    id: 'views.HistoryView.heading',
    defaultMessage: 'Historia'
  }
});



// WEBPACK FOOTER //
// ./src/views/History/HistoryView.intl.js